// @flow
import moment from 'moment';
import {
  FETCH_DRUG_LIST_SUCCESS,
  FETCH_DRUG_LIST_ERROR,
  FETCH_DRUG_LIST_LOADING,
  FETCH_DISPENSARY_SUCCESS,
  FETCH_DISPENSARY_ERROR,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_ERROR,
} from '../actions/pharmacyActions';

function buildDrugList(data: Object[]) {
  const archived = [];
  const expired = [];
  const expiring = [];
  const outOfStock = [];
  const lowStock = [];
  const drugList = {};

  // expired if expiration date past today
  const now = moment().startOf('day').toISOString();
  // expiring if expiration date in next 30 days
  const expiringDeadline = moment().add(30, 'day').startOf('day').toISOString();
  // low stock if less than 10 units
  const LOW_STOCK_THRESHOLD = 10;

  for (let i = 0; i < data.length; i++) {
    const drug = data[i];

    // Archived drugs
    if (drug.status === 1) {
      archived.push(drug);
      // eslint-disable-next-line no-continue
      continue;
    }

    // Expired/expiring lists
    if (drug.expirationDate && drug.expirationDate < now) {
      expired.push(drug);
    } else if (drug.expirationDate && drug.expirationDate < expiringDeadline) {
      expiring.push(drug);
    }

    // No or low stock
    if (drug.numberRemainingUnits <= 0) {
      outOfStock.push(drug);
    } else if (drug.numberRemainingUnits < LOW_STOCK_THRESHOLD) {
      lowStock.push(drug);
    }

    if (drug.category in drugList) {
      drugList[drug.category].push(drug);
    } else {
      drugList[drug.category] = [drug];
    }
  }
  return {
    archived,
    expired,
    expiring,
    outOfStock,
    lowStock,
    ...drugList,
  };
}

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case FETCH_DRUG_LIST_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case FETCH_DRUG_LIST_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: {
          ...state.data,
          drugList: buildDrugList(action.data),
        },
      };
    case FETCH_DISPENSARY_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: {
          ...state.data,
          dispensaryHistory: action.data,
        },
      };
    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: {
          ...state.data,
          transactionHistory: action.data,
        },
      };
    case FETCH_DRUG_LIST_ERROR:
    case FETCH_DISPENSARY_ERROR:
    case FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    case 'PHARMACY_FILTER_UPDATE':
      return {
        ...state,
        data: {
          ...state.data,
          pharmacyFilter: action.data,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/pharmacyReducer.js